import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import { ProfileConfig } from "@serie3/common/Modules/Profile/Resources/Endpoints";

/**
 * The current user's display name: Vorname and Name from the system profile
 * (the setup assistant fills it), same source the header uses. Empty while
 * loading or when nothing is configured; callers fall back to "- -".
 */
const useMyDisplayName = () => {
  const [name, setName] = useState("");
  useEffect(() => {
    let cancelled = false;
    crudApi
      .justGet(ProfileConfig.endpoints.systemProfile)
      .then((r) => {
        if (cancelled || !r?.ok) return;
        setName([r.data?.vorname, r.data?.name].map((x) => (x ?? "").trim()).filter(Boolean).join(" "));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return name;
};

export default useMyDisplayName;
